<template >
    <div class="ui-select-facebook-user">
        <div class="load-indicator" v-if="load">
            <div class="load">
                <ui-load-indicator :h="50" :stroke="8" bgColor="#e7e9f4" color="#69D296" />
            </div>
        </div>

        <div v-if="value.length > 0" class="items-wrapper">
            <div class="items-scroller">
                <div class="items">
                    <div v-for="option of value"
                        :key="option.id"
                        class="item">
                        <div>
                            <ui-facebook-user-card :data="option" :qtdAccounts="total" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
        
        <div v-else class="ui-no-content">
            <div class="title">Nenhuma conta do Facebook encontrada.</div>
        </div>
    </div>
</template>

<script>
    import uiFacebookUserCard from "../facebook-user-card"

    export default {
        components: { uiFacebookUserCard },

        props: {
            value: {
                type: Array,
                required: false,
                default() {
                    return []
                }
            },
            default: {
                type: Number,
                required: false,
            },
            load: {
                type: Boolean,
                required: false,
                default: false
            },
            total: {
                type: Number,
                required: false
            },
        },

        created() {
            this.$root.$on('transfer-account', (payload) => {
                let accounts = Object.values(this.value).filter(account => {
                    return account.id !== payload.id
                })
                this.$root.$emit('list-accounts-modal', { dataTransfer: accounts, select: payload })
            })
        },

        beforeDestroy() {
            this.$root.$off('transfer-account')
        }
    }
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>